import React from 'react';

import {
  CreditCardAmericanExpressIcon,
  CreditCardDiscoverIcon,
  CreditCardMasterCardIcon,
  CreditCardUnionIcon,
  CreditCardVisaIcon,
} from 'app/commonComponents/icons';
import { CreditCardIconContainer } from './styles';

const sharedStyle = {
  strokeWidth: '0',
};

const CreditCardIcons = () => {
  return (
    <CreditCardIconContainer aria-hidden="true">
      <CreditCardAmericanExpressIcon viewBox="0 -6 24 24" style={sharedStyle} />
      <CreditCardDiscoverIcon viewBox="0 -6 24 24" style={sharedStyle} />
      <CreditCardMasterCardIcon viewBox="0 -6 24 24" style={sharedStyle} />
      <CreditCardUnionIcon viewBox="0 -6 24 24" style={sharedStyle} />
      <CreditCardVisaIcon viewBox="0 -6 24 24" style={sharedStyle} />
    </CreditCardIconContainer>
  );
};

export default CreditCardIcons;
